export const WHITE_LABEL_DEFAULT_FILTER = {
  key: undefined,
};
